import type { UserProfile } from "../types/domain";

export function canRestoreProfile(profile: UserProfile | null, uid: string, email: string | null): profile is UserProfile {
  return Boolean(profile && profile.uid === uid && profile.accountStatus === "active" &&
    profile.username && profile.onboardingCompletedAt && profile.preferences &&
    (!email || profile.email?.toLowerCase() === email.toLowerCase()));
}

// A late cache result must never replace the fresh result.
export async function loadStartupProfile<T>(
  readCached: () => Promise<T>, readFresh: () => Promise<T>, publishCached: (value: T) => void
): Promise<T> {
  let freshSettled = false;
  const fresh = readFresh();
  void readCached().then((value) => {
    if (!freshSettled) publishCached(value);
  }).catch(() => undefined);
  try { return await fresh; }
  finally { freshSettled = true; }
}
